module.exports = __webpack_public_path__ + "static/media/sf-test-9.956e0b54.mp3";